import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-progress-step',
  templateUrl: './common-progress-step.component.html',
  styleUrls: ['./common-progress-step.component.scss']
})
export class CommonProgressStepComponent implements OnInit {
  @Input() stepIndex: number;

  @HostBinding('class.activeStep') 
   isActive = false;
   @Input() completed = false;

  @Input() public set activeState(step: CommonProgressStepComponent) {
    this.isActive = step === this;
  }
  
    constructor() { }

  ngOnInit(): void {
  }
}
